import type { BadgeColor } from '../components/Badge/Badge.types'

export function getVenueStatusBadgeColor(status: string): BadgeColor {
  if (status === 'OKAY') {
    return 'green'
  }
  if (status === 'OFFSALE') {
    return 'red'
  }
  return 'grey'
}
